import { ASSETS_TYPES, assetsCollectionElement } from '../types'

export function getAssetType(asset: assetsCollectionElement): ASSETS_TYPES | null {
  if (!asset || ('original_url' in asset && asset.original_url)) return ASSETS_TYPES.IMAGE
  if ('video' in asset && asset.video) return ASSETS_TYPES.VIDEO
  if ('file_url' in asset && asset.file_url) return ASSETS_TYPES.MODEL
  return null
}
